import globalStoreMutations from '@constans/store/global/globalStoreMutations';
const mutations = {
    [globalStoreMutations.UPDATE_LOADER]: (state, bool) => state.loading = bool,
    [globalStoreMutations.UPDATE_SNACBAR]: (state, data) => {
        let snackData = {
            show: false,
            status: '',
            message: ''
        };
        if (data !== null) {
            snackData.show = data.status && data.message ? true : false,
                snackData.status = data.status,
                snackData.message = data.message;
        }
        state.snackbar = snackData;
    }
};
export default mutations;
